/**
 * Generated by orval 🍺
 * Do not edit manually.
 * qcs control-plane
 * OpenAPI spec version: 0.1.0
 */

/**
 * What a flow is for, which is how the pages group jobs and runs.
 */
export type FlowCategory = typeof FlowCategory[keyof typeof FlowCategory];


export const FlowCategory = {
  availability: 'availability',
  discovery: 'discovery',
  rank: 'rank',
  catalog: 'catalog',
} as const;
